import React, { Component } from 'react';
import { AlertTriangleIcon } from 'lucide-react';
interface Props {
  children: ReactNode;
  fallback?: ReactNode;
}
interface State {
  hasError: boolean;
  error?: Error;
}
export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      hasError: false
    };
  }
  static getDerivedStateFromError(error: Error): State {
    return {
      hasError: true,
      error
    };
  }
  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error('[ErrorBoundary] Caught error:', error, errorInfo);
  }
  render() {
    if (this.state.hasError) {
      if (this.props.fallback) {
        return this.props.fallback;
      }
      return <div className="min-h-screen w-full bg-gradient-to-br from-slate-950 via-slate-900 to-slate-950 flex items-center justify-center p-8" data-id="element-606">
          <div className="max-w-md w-full bg-slate-900 border border-slate-800 rounded-2xl p-8 text-center" data-id="element-607">
            <div className="w-16 h-16 bg-red-500/10 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-608">
              <AlertTriangleIcon className="w-8 h-8 text-red-400" data-id="element-609" />
            </div>
            <h2 className="text-2xl font-bold text-white mb-2" data-id="element-610">
              Something went wrong
            </h2>
            <p className="text-slate-400 mb-6" data-id="element-611">
              We encountered an unexpected error. Please refresh the page to try
              again.
            </p>
            <button onClick={() => window.location.reload()} className="px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white rounded-lg transition-colors" data-id="element-612">
              Refresh Page
            </button>
          </div>
        </div>;
    }
    return this.props.children;
  }
}